module.exports = __webpack_public_path__ + "img/09.6563a204.png";